import Vue from "vue";
export default {
    namespaced: true,
    state: {
        items: [],
        value: null
    },

    getters: {
        items(state,) {
            return state.items;
        },
    },

    mutations: {
        SELECT_PROGRAMA(state, item) {
            state.value = item;
        },
        SET_PROGRAMAS(state, items = []) {
            state.items = [...state.items, ...items];
        },
        ADD_PROGRAMA(state, oneItem) {
            state.items.push(oneItem);
        },
        REPLACE_PROGRAMA(state, oneItem, index) {
            state.items[index] = oneItem;
        },
        DELETE_PROGRAMA(state, Id) {
            const ind = state.items.findIndex(program => program.id === Id);
            if (ind !== -1) {
                state.items.splice(ind, 1);
            }
        },

        EDIT_PROGRAMA(state, { Id, program }) {
            const ind = state.items.findIndex(program => program.id === Id);

            if (ind !== -1) {
                Vue.set(state.items, ind, program);
            }
        }
    },

    actions: {
        selectPrograma({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === data.id);
            return exitsItem ? (commit('SELECT_PROGRAMA', data), true) : false;
        },

        setProgramas({ state, commit }, data = []) {
            // window.console.log('setProgramassetProgramas',data);
            data.forEach(program => {
                const index = state.items.findIndex(item => item.id == program.id)
                if (index === -1) {
                    commit('ADD_PROGRAMA', program);
                } else {
                    commit('REPLACE_PROGRAMA', program, index);
                }
            });
            return true;
        },

        addPrograma({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === data.id);
            return !exitsItem ? (commit('ADD_PROGRAMA', data), true) : false;
        },

        deletePrograma({ state, commit }, id) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === id);
            return exitsItem ? (commit('DELETE_PROGRAMA', id), true) : false;
        },

        // editPrograma({ commit }, data) {
        //     return new Promise(resolve => {
        //         setTimeout(() => {
        //             commit('EDIT_PROGRAMA', data);
        //             resolve();
        //         }, 250);
        //     });
        // }
    }
};
